import ListTable from "common/ListTable";

const SewingToFoldingTable = (props) => {
  const { total, loading, defaultCurrent, pageSize, current, onChange } = props;

  return (
    <>
      {/* {props.filter && (
        <CustomFilter
          showFilter={showFilter}
          handleFilter={handleFilter}
          tableData={props.dataSource}
          fetchTableData={null}
          filterName="buying_office"
        />
      )} */}
      <div className="table" style={{ marginTop: 10 }}>
        <ListTable
          loading={loading}
          emptyText="No records to show yet."
          pagination={{
            showSizeChanger: false,
            defaultPageSize: pageSize,
            current: current,
            onChange: onChange,
            defaultCurrent: defaultCurrent,
            total: total,
          }}
          columns={props?.tableColumns?.map((col, idx) => ({
            ...col,
            fixed: idx < 4 ? "left" : undefined,
          }))}
          scroll={{
            x: 1200,
            y: 500,
          }}
          dataSource={props.dataSource}
          // scroll={{ x: "max-content" }}
        />
      </div>
    </>
  );
};
export default SewingToFoldingTable;
